import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

import { EditAccessorialState } from "@tKgpco/Store/Data/Accessorials/AccessorialsState";

const initialState: EditAccessorialState = {
    isLoading: false,
    accessorial: null as any,
};
export const reducer = {
    "Custom/EditAccessorials/BeginLoad": (draft: Draft<EditAccessorialState>) => {
        draft.isLoading = true;
    },
    "Custom/EditAccessorials/CompleteLoad": (draft: Draft<EditAccessorialState>, action: EditAccessorialState) => {
        draft.isLoading = false;
        draft.accessorial = action.accessorial;
    },
    "Custom/EditAccessorials/FailedToLoadAccessorials": (draft: Draft<EditAccessorialState>) => {
        draft.isLoading = false;
        draft.accessorial = null as any;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
